<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-layout>
            <v-flex xs3>
              <span class="accent--text" style="font-size: 18px; font-weight:700;"> Penalty Report </span>
            </v-flex>
            <v-spacer>
            </v-spacer>
            <v-flex xs3>
              <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
            </v-flex>
            <v-spacer>
            </v-spacer>
            <v-flex xs3>
              <v-text-field v-model="search" append-icon="search" label="Search"
                            single-line hide-details color="primary"></v-text-field>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="penalties"
            class="elevation-1"
            :search="search"
            :options.sync="pagination"
            :items-per-page="itemsPerPage"
            :hide-default-footer="false"
            :item-key="(item, index) => index"
          >
            <template v-slot:[`header.eslipNumber`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.invoiceId`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.season`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.saleNumber`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.amount`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.buyerId`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`item.dateCreated`]="{ item }">
              {{item.dateCreated }}
            </template>
            <template v-slot:[`item.dateUpdated`]="{ item }">
              {{item.dateUpdated }}
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from '../../../config'
import axios from 'axios'
import * as XLSX from 'xlsx'

export default {
	name: 'penaltyReport',
	data: function () {
		return {
			headers: [
				{ text: 'ESLIP NUMBER', value: 'eslipNumber' },
				{ text: 'INVOICE NUMBER', value: 'invoiceId' },
				{ text: 'SEASON', value: 'season' },
				{ text: 'SALE NUMBER', value: 'saleNumber' },
				{ text: 'INVOICE AMOUNT', value: 'invoiceAmount' },
				{ text: 'PENALTY AMOUNT', value: 'amount' },
				{ text: 'BUYER NAME', value: 'buyerName' },
				{ text: 'PAYMENT STATUS', value: 'statusName' },
				{ text: 'DATE CREATED', value: 'dateCreated' },
				{ text: 'DATE PAID', value: 'datePaid' },
				{ text: 'DAYS DELAYED', value: 'daysDelayed' },
				{ text: 'PENALTY RATE', value: 'penaltyRate' }
			],
			penalties: [],
			message: '',
			error: '',
			loading: true,
			totalOrganizations: 0,
			snackbarColor: '',
			snackbar: false,
			permissions: [],
			search: '',
			editDialog: false,
			valid: true,
			startDateMenu: false,
			startDate: null,
			institutionTypes: [],
			e1: 1,
			currencies: [],
			page: 1,
			totalPages: 0,
			pageSize: 5,
			pageSizes: [5, 10],
			paginatedItems: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			generatedOrganizations: [],
			genpaginatedItems: [],
			genNumberOfLinks: 0,
			generatedOrganizationsPage: 1,
			penalty: {
				eslipNumber: '',
				invoiceId: '',
				season: '',
				saleNumber: '',
				amount: '',
				buyerId: '',
				dateCreated: '',
				dateUpdated: ''
			}
		}
	},
	mounted () {
		this.getPenalties()
	},
	methods: {
		getPenalties: function () {
			const url = config.serverURI + '/reports/penalty-report'
			axios.get(url)
				.then(response => {
					const items = response.data
					items.forEach(item => {
						item.penaltyRate = 14 / 100
						item.datePaid = item.datePaid ? this.formatDate(item.datePaid) : null
						// item.dateCreated = item.dateCreated ? this.formatDateCreated(item.dateCreated) : null
					})
					this.penalties = items
					// this.totalPages = totalPages
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			return this.penalties
		},
		exportToExcel () {
			const exportData = this.penalties.map(transaction => ({
				'ESLIP NUMBER': transaction.eslipNumber,
				'INVOICE NUMBER': transaction.invoiceId,
				SEASON: transaction.season,
				'SALE NUMBER': transaction.saleNumber,
				'INVOICE AMOUNT': transaction.invoiceAmount,
				'PENALTY AMOUNT': transaction.amount,
				'BUYER NAME': transaction.buyerName,
				'STATUS NAME': transaction.statusName,
				'DATE CREATED': transaction.dateCreated,
				'DATE PAID': transaction.datePaid,
				'DAYS DELAYED': transaction.daysDelayed,
				'PENALTY RATE': transaction.penaltyRate
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'penaltyData')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'penalty_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		},
		truncateDecimal (value) {
			if (!isNaN(value)) {
				// Check if the number is a whole number
				if (Number.isInteger(value)) {
					return value.toString() // Return as a string to avoid displaying trailing .00
				} else {
					return parseFloat(value).toFixed(2) // Truncate to 2 decimal places
				}
			}
			return value
		},
		formatDate (timestamp) {
			const date = new Date(timestamp)
			return date.toLocaleDateString() // Formats date to a string in mm/dd/yyyy format
		},
		formatDateCreated (inputDateString) {
			// Parse the input date string
			const parsedDate = new Date(inputDateString)

			// Create a new date by adding 462 days (1 year + 3 months + 4 days) to the parsed date
			parsedDate.setDate(parsedDate.getDate() + 462)

			// Format the new date to "DD/MM/YYYY"
			const formattedDate = `${String(parsedDate.getDate()).padStart(2, '0')}/${String(parsedDate.getMonth() + 1).padStart(2, '0')}/${parsedDate.getFullYear()}`

			return formattedDate
		}
	}
}
</script>

<style scoped>

</style>
